import type { ReactNode } from 'react';

export function Panel({
  title,
  actions,
  children,
  className = '',
  size = 'md',
}: {
  title?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  size?: 'md' | 'lg';
}) {
  return (
    <section
      className={`${size === 'lg' ? 'hud-cut-lg' : 'hud-cut'} border border-line bg-panel p-4 ${className}`}
    >
      {title || actions ? (
        <div className="mb-3 flex items-center justify-between gap-2">
          {title ? (
            <h2 className="font-display text-xs font-bold uppercase tracking-[0.18em] text-muted">
              {title}
            </h2>
          ) : (
            <span />
          )}
          {actions}
        </div>
      ) : null}
      {children}
    </section>
  );
}
